import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { CustomRadioItem, CustomRadioProps } from "./type";

const CustomRadio = (props: CustomRadioProps): React.ReactElement => {
  const {
    value,
    items,
    defaultValue,
    onValueChange,
    className,
    radioCss,
    isDisabled,
    errors,
  } = props;
  return (
    <>
      <RadioGroup
        value={value}
        defaultValue={defaultValue}
        onValueChange={onValueChange}
        disabled={isDisabled}
        className={`w-fit flex items-start ${radioCss}`}
      >
        {items.map((item: CustomRadioItem, index: number) => (
          <div key={index} className={`flex items-center gap-2 ${className}`}>
            <RadioGroupItem
              value={item.value}
              id={item.id}
              disabled={isDisabled}
            />
            <label htmlFor={item.htmlFor ? item.htmlFor : item.id}>
              {item.label}
            </label>
          </div>
        ))}

        <div className="flex items-center gap-2" />
      </RadioGroup>
      {errors && <p className="mt-1 text-sm text-red-500">{errors}</p>}
    </>
  );
};

export default CustomRadio;
